import { createContext } from 'react';

/**
 * @public
 */
var PresenceContext = /*#__PURE__*/createContext(null);
export { PresenceContext };